import { API_URL } from "api/API";
import getForecastDevDelayApi from "api/forecast/getForecastDevDelayApi";
import { obsDatetimeState } from "libs/atoms";
import { useMemo } from "react";
import { useQuery } from "react-query";
import { useRecoilValue } from "recoil";
import styled from "styled-components";

const Text = styled.span<{isWarning: boolean;}>`
  color: ${props => props.isWarning ? "#e84118" : props.theme.textColor};
`;

interface DevUpdateDelayProps {
  updatedAt: string;
  type: "satImage" | "forecast",
  text: string;
}

const DevUpdateDelay = ({updatedAt, type, text}: DevUpdateDelayProps) => {
  const {data, isLoading} = useQuery({
    queryKey: [API_URL.FORECAST.GET_DEV_DELAY], 
    queryFn: getForecastDevDelayApi, 
    cacheTime: Infinity, 
    staleTime: Infinity
  });
  const obsDatetime = useRecoilValue(obsDatetimeState);

  const isDelay = useMemo(() => {
    if (!obsDatetime || !data || !updatedAt) return false;

    const korDatetime = new Date(`${obsDatetime[5].date} ${obsDatetime[5].time}`);
    const updatedAtDate = new Date(updatedAt);

    const diff = (korDatetime.getTime() - updatedAtDate.getTime()) / 1000;
    const delay = type === "satImage" ? data.sat_image : data.forecast;

    return diff > delay;
  }, [obsDatetime, data, updatedAt])
  
  return <Text isWarning={isDelay}>{text}</Text>
}

export default DevUpdateDelay;